import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Profile } from '@vgtv/api-client/lib/cnp_tag';

import { fetchHelper } from '../../helpers/fetch';
import type { Vendor } from '../../types';

export const fetchProfiles = createAsyncThunk(
  'profiles/fetch',
  ({ dataUrl }: { dataUrl: string; vendor: Vendor }) => {
    return fetchHelper<Profile[]>(dataUrl);
  }
);
